"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeadObjectInput_1 = require("./HeadObjectInput");
var HeadObjectOutput_1 = require("./HeadObjectOutput");
var NoSuchKey_1 = require("./NoSuchKey");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.HeadObject = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "HeadObject",
    http: {
        method: "HEAD",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: HeadObjectInput_1.HeadObjectInput
    },
    output: {
        shape: HeadObjectOutput_1.HeadObjectOutput
    },
    errors: [
        {
            shape: NoSuchKey_1.NoSuchKey
        }
    ]
};
//# sourceMappingURL=HeadObject.js.map